// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoListItem_container__rMxAD","header":"InfoListItem_header__2Izz6","timestamp":"InfoListItem_timestamp__3x3jM","content":"InfoListItem_content__3QpFp"};